import { Component, ViewChild } from '@angular/core';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../../core/components/sidebar/sidebar.component';
import {NgClass, NgIf} from '@angular/common';
import { NzIconDirective } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [NzLayoutModule, RouterOutlet, SidebarComponent, NzIconDirective, NgClass],
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent {
  isCollapsed = false;

  @ViewChild(SidebarComponent) sidebarComponent!: SidebarComponent;

  toggleSidebar(): void {
    this.sidebarComponent.toggleSidebar();
    this.isCollapsed = !this.isCollapsed;
  }
}
